const BoxLogList = () => import('Views/log/box-log-list');
const BoxLogDetail = () => import('Views/log/box-log-detail');
const LogList = () => import('Views/log/log-list');
const LogDetail = () => import('Views/log/log-detail');

export default[
  { path: '/box-log-list', component: BoxLogList },
  { path: '/log-list', component: LogList },
  { path: '/box-log-detail/:id', component: BoxLogDetail },
  { path: '/log-detail/:id', component: LogDetail },
];



// WEBPACK FOOTER //
// ./src/router/log.js